// @ts-ignore
import template from './editable-field.template.html';

export default function() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      entity: "=",
      displayKey: "=",
      onChange: "&",
      featureEnabled: "=" // defaults to true if not present
    },
    compile: function(element, attrs) {
        // Note this looks like it overrides false, but it does not -
        // attrs.featureEnabled will contain the text from the
        // original HTML document (not the evaluated bound value)
        // at this point. e.g. "isEarlyAdopter()" vs. false
        if (!attrs.featureEnabled) { attrs.featureEnabled = "true"; }
    },
    controller: ['$scope', '$timeout', function ($scope, $timeout) {
      $scope.state = "view";

      $scope.getInput = function() {
        return document.querySelector("#accountName-" + $scope.entity.id + " .edit input");
      };

      $scope.displayValue = function() {
        return $scope.entity[$scope.displayKey];
      };

      $scope.editField = function() {
        $scope.state = "edit";

        $timeout(function() {
          $scope.getInput().focus();
        });
      };

      $scope.cancelField = function() {
        $scope.state = "view";
        $scope.getInput().value = $scope.displayValue();
      };

      $scope.saveField = function() {
        $scope.getInput().disabled = true;

        return $scope
          .onChange({entity: $scope.entity, newValue: $scope.getInput().value})
          .then(function() {
            $scope.getInput().disabled = false;
            $scope.state = "view";
            $scope.$applyAsync();
          });
      };

      $scope.keyWasPressed = function(evt) {
        if (evt.keyCode == 27) {
          $scope.cancelField();

        } else if (evt.keyCode == 13) {
          $scope.saveField();
        }
      };
    }]
  };
}

